// extracted by mini-css-extract-plugin
module.exports = {"link":"Link_link__16_PZ","link-animation":"Link_link-animation__3L2cm","accent":"Link_accent__3v84h","regular":"Link_regular__1Dbwn"};